export default __webpack_public_path__ + "static/media/NCIceland.a03f9826.png";